import { render, staticRenderFns } from "./topJapanMap.vue?vue&type=template&id=bda55e52&"
import script from "./topJapanMap.vue?vue&type=script&lang=js&"
export * from "./topJapanMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports